// -------------------------------------
//  ScrollTop
// -------------------------------------
export default function ScrollTop(mySelector){
  $(mySelector).on('click', function(e){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 400);
  });
  $('.js-scrollTop').hide();
  $(window).scroll(function() {
    if ($(this).scrollTop() > 500) {
      $('.js-scrollTop').fadeIn();
    } else {
      $('.js-scrollTop').fadeOut();
    }
  });
}
